import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col, Tooltip } from "antd";
import moment from "moment";
import PropTypes from 'prop-types';
import { checkBoxSelect } from "../Pages/actions";
import DocumentCard from './../../../CommonComponents/Cards/DocumentCard/DocumentCard';

import {
  GridViewMainWrapper,
} from "./styles";

import { getPrimaryAccount } from "../../../utils/sessionUtil";
import { downloadFileFromUrl } from '../../../services/apiServices';
export class GridViewComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkboxGrid: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.checkbox !== this.props.checkbox) {
      if (nextProps.checkbox !== null) {
        if (nextProps.checkbox) {
          this.updateSelectedData();
        } else {
          this.removeSelectedData();
        }
      }
    }
  }

  downLoadFile(docId, id1, id2, docName) {
    const download = docName.toLowerCase() === "account documentation";
    if(download && docId !== 0) {
      let url = `/donor-portal/api/account/${getPrimaryAccount().userId}/getAccountDocumentsByAccountIdAndDocId?docId=${docId}`;
      downloadFileFromUrl(url);
    }

  }

  updateSelectedData() {
    let selectedFiles = this.props.selectedFiles;
    selectedFiles[this.props.eachId].foreach(each => (each.selected = true));
    let selectedCheckBoxArray = this.props.selectedLinks
      ? this.props.selectedLinks
      : [];

    let totalData = this.props.arrayData[this.props.eachId][1];
    if (selectedCheckBoxArray.length > 0) {
      for (let i = (selectedCheckBoxArray.length - 1); i >= 0; i--) {
        if (selectedCheckBoxArray[i]["gridIndex"] === this.props.eachId) {
          selectedCheckBoxArray.splice(i, 1);
        }
      }
    }
    for (let i = 0; i < totalData.length; i++) {
      selectedCheckBoxArray.push({
        gridIndex: this.props.eachId,
        indexVal: i,
        accordionName: this.props.docVal[0],
        name: totalData[i]["name"],
        link: totalData[i]["link"],
        date: totalData[i]["date"]
      });
    }
    this.props.checkBoxChange({ "selected": selectedCheckBoxArray, selectedFiles });
  }

  removeSelectedData() {
    let selectedFiles = this.props.selectedFiles;
    selectedFiles[this.props.eachId].foreach(each => (each.selected = false));
    let selectedCheckBoxArray = this.props.selectedLinks
      ? this.props.selectedLinks
      : [];
    if (selectedCheckBoxArray.length > 0) {
      for (let i = (selectedCheckBoxArray.length - 1); i >= 0; i--) {
        if (selectedCheckBoxArray[i]["gridIndex"] === this.props.eachId) {
          selectedCheckBoxArray.splice(i, 1);
        }
      }
    }
    this.props.checkBoxChange({ "selected": selectedCheckBoxArray, selectedFiles });
  }

  render() {
    let docVal = this.props.docVal[1];
    const docName = this.props.docVal[0];

    return (
      <Row data-test="document-center-grid-view">
        {docVal && docVal.map((each, index) => {
          {
            if (index < 4) {
              return (
                <GridViewMainWrapper key={index}>
                  <Col
                    lg={{ span: 6 }}
                    xs={{ span: 24 }}
                    md={{ span: 12 }}
                    xl={{ span: 5 }}
                  >
                    <DocumentCard
                      data-test="receipt-action"
                      key={each.docId}
                      newIcon={false}
                      docName={docName}
                      receipt={each}
                      handleViewAnalytics={this.downLoadFile}
                      myDocument
                      indexKey={index+this.props.id}
                    />
                  </Col>
                </GridViewMainWrapper>
              );
            } else if (this.props.showMore) {
              return (
                <GridViewMainWrapper key={index}>
                  <Col
                    lg={{ span: 6 }}
                    xs={{ span: 24 }}
                    md={{ span: 12 }}
                    xl={{ span: 5 }}
                  >
                    <DocumentCard
                      data-test="receipt-action"
                      key={each.docId}
                      newIcon={false}
                      docName={docName}
                      receipt={each}
                      handleViewAnalytics={this.downLoadFile}
                      myDocument
                      indexKey={index+this.props.id}
                    />
                  </Col>
                </GridViewMainWrapper>
              );
            } else {
              return false;
            }
          }
        })}
      </Row>
    );
  }
}

GridViewComponent.propTypes = {
  arrayData: PropTypes.array,
  checkbox: PropTypes.bool,
  docVal: PropTypes.array,
  eachId: PropTypes.number,
  selectedFiles: PropTypes.array,
  selectedLinks: PropTypes.array,
  showMore: PropTypes.bool,
  checkBoxChange: PropTypes.func.isRequired,
  handleCheckboxChange: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  arrayData: state.getIn(["documentCentre", "docCentreData", "arrayData"]),
  selectedLinks: state.getIn(["documentCentre", "checkboxArray", "selected"]),
  selectedFiles: state.getIn(["documentCentre", "checkboxArray", "selectedFiles"])
});

export const mapDispatchToProps = dispatch => ({
  checkBoxChange: val => dispatch(checkBoxSelect(val))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GridViewComponent);
